/**
 * Copy used by the organization registration form. Keeping strings in one
 * place keeps the component focused on layout/state.
 */

export const ORG_REGISTRATION_FORM_COPY = {
  SECTION_TITLE: 'Create your organization',
  ORG_NAME_LABEL: 'Organization name *',
  ORG_NAME_PLACEHOLDER: 'e.g. Acme Sports Club',
  DISPLAY_NAME_LABEL: 'Display name',
  DISPLAY_NAME_PLACEHOLDER: 'How members see it (optional)',
  INDUSTRY_LABEL: 'Industry',
  DESCRIPTION_LABEL: 'Description',
  DESCRIPTION_PLACEHOLDER: 'Short tagline (optional)',
  WEBSITE_LABEL: 'Website',
  WEBSITE_PLACEHOLDER: 'www.example.com (optional)',
  PHONE_LABEL: 'Phone number',
  PHONE_PLACEHOLDER: '+14155552671 (optional)',
  SUBMIT_BUTTON: 'Create Organization',
  ERROR_FALLBACK_VALIDATION: 'Please check your input and try again.',
} as const
